import List from './views/List'

export default [{
  path: '/jobs/list',
  name: 'jobs.list',
  component: List
}]
